import React from 'react';
import { Link } from 'react-router-dom'
import pageNO from '../../Assets/Images/PageNotFound (2).png'

const NoProductFound = () => {
    return (
        <div className="container">
            <div className="row mt-4">
                <div className="col-md-12 text-center">
                    <h4 className='fw-bold'>
                    Sorry! No product found
                    </h4>
                    <p className='text-center'>
                    We could not find any product.<br/>
                    Please try different keyword or explore other categories.  
                    </p>
                    <img src={pageNO} alt='pageNotFound'/>
                    <div className='col-md-12 d-flex justify-content-center align-item-center'>
                    {/* <Link to='/'
                    className='text-decoration-none mt-4'>
                    <button className='btn  py-1 rounded-5 px-5 me-5'
                    style={{border: '1px solid #5E6B49',color:'#5E6B49'}}>Go to Homepage</button>
                    </Link> */}
                    </div>
                    
                </div>
            </div>
        </div>
      )
}

export default NoProductFound